import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import testi from '../../Asset/57173.jpg'
const testimonials = [
  {
    name: "Aliza Anney",
    designation: "Model Belarus",
    profileImage: "https://via.placeholder.com/80", // Replace with actual image
    quote:
      "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour.",
  },
  {
    name: "John Doe",
    designation: "Business Owner",
    profileImage: "https://via.placeholder.com/80",
    quote:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. It has survived not only five centuries.",
  },
];

const Testimonial = () => {
  return (
    <div className="flex items-center justify-center  mt-5
     px-6">
      <div className="max-w-6xl w-full flex  overflow-hidden">
       

        {/* Right Side Content */}
        <div className="w-full md:w-2/3 p-10">
          <h2 className="text-[#b7b7a1] text-sm uppercase mb-2">-What People Say</h2>
          <h1 className="text-3xl font-bold mb-6">Client Testimonial</h1>

          {/* Swiper Slider */}
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            // navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000 }}
            loop
            className="w-full"
          >
            {testimonials.map((testimonial, index) => (
              <SwiperSlide key={index}>
                <div className="text-left">
                  {/* Quote */}
                  <p className="text-gray-600 text-lg italic leading-relaxed mb-6">
                    <span className="text-4xl font-serif text-[#b7b7a1]">“</span>
                    {testimonial.quote}
                  </p>

                  {/* Client Info */}
                  <div className="flex items-center mt-6">
                    <img
                      src={testimonial.profileImage}
                      alt={testimonial.name}
                      className="w-12 h-12 rounded-full border-2 border-gray-300"
                    />
                    <div className="ml-4">
                      <h3 className="text-lg font-semibold">{testimonial.name}</h3>
                      <p className="text-sm text-gray-500">{testimonial.designation}</p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
         {/* Left Side Image */}
         <div className="w-1/3 hidden md:block">
          <img
            src={testi}// Replace with the actual person image
            alt="Client"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
